/* tslint:disable:ext-variable-name */
import { Guid } from "cms-infrastructure-javascriptextensions/Guid";
import { LogType } from "./LogType";
export class LogItem {
    /**
     * Initializes a new instance of the `LoggingService` class.
     * @constructor
     * @param message {message} Log message.
     * @param data {any} Any additional JSON data.
     * @param logType {LogType} Type of the log.
     * @param activityId {string} Activity Id.
     * @param logTime {Date} Time of the log.
     * @param parentActivityId {string} Parent activity id.
     */
    constructor(message, data, logType, activityId, logDateTime, parentActivityId) {
        this.Message = message || "";
        this.LogType = logType || LogType.Default;
        this.ActivityId = activityId || Guid.newGuid();
        this.LogDateTime = logDateTime || new Date();
        this.ParentActivityId = parentActivityId || "";
        if (data) {
            if (typeof (data) !== "object") {
                data = { data: data };
            }
            this.Data = data;
        }
    }
}
//# sourceMappingURL=LogItem.js.map